import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import './NotFound.css'

export default function NotFound() {
  return (
    <section className="not-found">
      <SEO
        title="Page Not Found | AS Elite Gatherings"
        description="The page you're looking for may have moved."
        path="/404"
        noindex
      />
      <div className="container not-found-inner">
        <span className="not-found-code">404</span>
        <h1>This gathering doesn't exist — yet</h1>
        <p>The page you're looking for may have moved. Let's get you back on track.</p>
        <Link to="/" className="btn btn-primary">Back to Home</Link>
      </div>
    </section>
  )
}
